import Date from './Date'
import Input from './Input'
import Select from './Select'
import Checkbox from './Checkbox'

export const Fields = {
  date: Date,
  text: Input,
  select: Select,
  checkbox: Checkbox,
}
